import styled from "styled-components";
import {DepositSideMenuItemDefaultBox} from "./deposit-side-menu-item.default.box";


export const DepositSideMenuItemCasino777Box = styled(DepositSideMenuItemDefaultBox)`
    color: ${props => props.theme.colors.moneyColor};
`;
